import { render, staticRenderFns } from "./NoItem.vue?vue&type=template&id=d23f6198&"
import script from "./NoItem.vue?vue&type=script&lang=js&"
export * from "./NoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports